<template>
  <a :href="broadcast.url"
     class="bx-epg-broadcast"
     :class="{ 'bx-epg-broadcast--on-air': onAir }">
    <div>
      <span>{{ broadcast.categoryName }}</span>
      <span>{{ broadcast.genreName }}</span>
    </div>
    <div>{{ broadcast.title }}</div>
    <div>
      <div v-if="progress > 0 && progress < 100"
           :style="{ width: progress + '%' }" />
    </div>
    <div>
      <span>{{ formatTime(broadcast.airTime) }}-{{ formatTime(broadcast.airTimeEnd) }}</span>
      <VodEpgBadges :badges="broadcast.flags"
                    :inline-usage="true" />
      <div v-if="showPlayIcon"
           class="bx-badges bx-badges--below-teaser-content">
        <svg class="bx-badge bx-badge--video icon icon-play">
          <use href="/images/icon_sprite.svg#play" />
        </svg>
      </div>
    </div>
  </a>
</template>

<script>
import { format } from 'date-fns-tz'

import epgAirTimeHelper from '../mixins/epg-air-time-helper'
import VodEpgBadges from '../../../../components/shared/vod-epg/Badges.vue'

export default {
  components: {
    VodEpgBadges
  },
  mixins: [epgAirTimeHelper],
  props: {
    broadcast: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      progress: 0,
      onAir: false
    }
  },
  computed: {
    showPlayIcon () {
      return this.broadcast.hasAutoPlay
    }
  },
  mounted () {
    this.updateProgress()
  },
  methods: {
    formatTime (timestamp) {
      const date = new Date(timestamp)

      // explicitly convert to our timezone to ensure consistent display
      // example: a request from san francisco (google) won't be 11:15 am but 20:15 - https://bauerxcel.atlassian.net/browse/NXT-8158
      const airTime = this.forceDateIntoTimeZone(date)

      return format(airTime, 'HH:mm')
    },
    updateProgress () {
      const now = Date.now()
      const start = new Date(this.broadcast.airTime).getTime()
      const end = new Date(this.broadcast.airTimeEnd).getTime()

      this.progress = now < start
        ? 0
        : now >= end
          ? 100
          : ((now - start) / (end - start)) * 100

      this.onAir = now >= start && now <= end
    }
  }
}
</script>
